import { get, post, put, del } from 'utils/methods';

export function getPromotionsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}promotions`, data, headers);
}

export function addNewPromotionApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/promotion`, data, headers);
}

export function editPromotionApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/promotion`, data, headers);
}

export function attachResellersProductGroupToPromotionApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/promotion/apply`, data, headers);
}

export function updateTranslatePromotionApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/promotion/translate`, data, headers);
}

export function getSellPrices(data, headers) {
    return get(`${process.env.REACT_APP_REST}promotion/sell-prices`, data, headers);
}

export function deleteSellPricesApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}promotion/sell-prices`, data, headers);
}

export function updateSellPricesApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/promotion/apply`, data, headers);
}

export function enableDisablePromotionApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/promotion/status`, data, headers);
}
